import React from 'react'
import Navbar from '../inc/Navbar'
import Slider from '../inc/Slider'
import HomeForm from './HomeFrom'
import HidenIcon from './HidenIcon'
import About from './About'
import Popup from './Popup'
import SlideButton from './SlideButton'
import "./Home.css";
import PropertyCards from './PropertyCards'



function Home() {
    
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 mt-3">
                            <Slider />
                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="cardback">
                                <HomeForm />

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <SlideButton/>
            <HidenIcon/>
            <br/>
            <About/>
            <br/>
<PropertyCards/>
<Popup/>
        </div>
    )
}

export default Home